class personDetailsService {
  static setDoctorsDetail(data) {
    if (data) {
      sessionStorage.setItem('doctorsDetail', JSON.stringify(data));
    }
  }

  static getDoctorsDetail() {
    const data = sessionStorage.getItem('doctorsDetail');
    return data ? JSON.parse(data) : [];
  }

  static clearDoctorsDetail() {
    sessionStorage.removeItem('doctorsDetail');
  }
}

export default personDetailsService;
